module.exports = __webpack_public_path__ + "static/media/youtube-logo.197b3659.png";